module.exports = __webpack_public_path__ + "img/result-detail-communication-inright03.8ad0fdad.svg";